const middleware = {}

middleware['async-middlewares'] = require('../middleware/async-middlewares.js')
middleware['async-middlewares'] = middleware['async-middlewares'].default || middleware['async-middlewares']

middleware['async-middlewares/page-seo'] = require('../middleware/async-middlewares/page-seo.js')
middleware['async-middlewares/page-seo'] = middleware['async-middlewares/page-seo'].default || middleware['async-middlewares/page-seo']

middleware['confirm-route-change'] = require('../middleware/confirm-route-change.js')
middleware['confirm-route-change'] = middleware['confirm-route-change'].default || middleware['confirm-route-change']

middleware['helpers'] = require('../middleware/helpers.js')
middleware['helpers'] = middleware['helpers'].default || middleware['helpers']

export default middleware
